<!-- 
	Settings
	role: User
  Settings page to allow user to update account information or link to change password or optout request
-->

<template>
	<div class="enroll-now text-white">
		<div v-if="user.loggedIn === true">
			<div class="flex flex-row justify-between">
				<router-link to="/user">
					<CustomButton>Back</CustomButton>
				</router-link>
			</div>
			<div class="flex flex-col sm:flex-row">
				<div>
                    <div class='title uppercase'>Enroll Now</div>
					<UpdateFormTickets v-bind:user="user" />
				</div>
			</div>
		</div>
		<div v-else>NO USER</div>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";

	import UpdateFormTickets from "@/components/UpdateFormTickets";
	import CustomButton from "@/components/CustomButton";

	export default {
		name: "EnrollNow",
		components: {
			CustomButton,
			UpdateFormTickets,
		},
		computed: {
			...mapGetters({
				user: "user",
			}),
		},
	};
</script>
<style scoped>
    .title {
		font-size: 36px;
		color: #c1b59b;
        text-align: center;
    }
</style>